import { Routes } from '@angular/router';
import { EventDetailComponent } from './components/admin/event-detail/event-detail.component';
import { EventRegistrationsComponent } from './components/admin/event-registrations/event-registrations.component';
import { SelectEventComponent } from './components/admin/select-event/select-event.component';
import { LoginComponent } from './components/authnz/login/login.component';
import { SetPasswordComponent } from './components/authnz/set-password/set-password.component';
import { ResetPasswordComponent } from './components/authnz/reset-password/reset-password.component';
import { NotAuthorisedComponent } from './components/authnz/not-authorised/not-authorised.component';
import { NotFoundComponent } from './components/authnz/not-found/not-found.component';
import { AdminLayoutComponent } from './components/layouts/admin-layout/admin-layout.component';
import { RegistrationLayoutComponent } from './components/layouts/registration-layout/registration-layout.component';
import { SimpleLayoutComponent } from './components/layouts/simple-layout/simple-layout.component';
import { PaymentPendingComponent } from './components/registrations/payment-pending/payment-pending.component';
import { RegistrationCancelComponent } from './components/registrations/registration-cancel/registration-cancel.component';
import { RegistrationConfirmComponent } from './components/registrations/registration-confirm/registration-confirm.component';
import { RegistrationWrapperComponent } from './components/registrations/registration-wrapper/registration-wrapper.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { authnGuard } from './guards/authn.guard';
import { authzGuard } from './guards/authz.guard';
import { eventExistsGuard } from './guards/event-exists.guard';
import { UsersComponent } from './components/admin/users/users.component';
import { RegistrationFlowGuard } from './guards/registration-flow-guard.guard';
import { eventResolver } from './resolvers/event-resolver.resolver';
import { EventEditComponent } from './components/admin/event-edit/event-edit.component';


export const routes: Routes = [
  {
    path: 'admin',
    component: AdminLayoutComponent,
    data: { breadcrumb: 'Admin' },
    children: [
      {
        path: '',
        redirectTo: 'events',
        pathMatch: 'full'
      }, {
        path: 'users',
        component: UsersComponent,
        data: { breadcrumb: 'Users' },
      }, {
        path: 'events',
        data: { breadcrumb: 'Events' },
        children: [
          {
            path: '',
            component: SelectEventComponent,
            data: { breadcrumb: 'Events' },
          },
          {
            path: 'new',
            component: EventEditComponent,
            data: { breadcrumb: 'New event' },
          },
          {
            path: ':eventname',
            data: { breadcrumb: ':eventname' },
            canActivate: [eventExistsGuard],
            resolve: { event: eventResolver },
            children: [
              {
                path: '',
                component: EventDetailComponent,
                data: { breadcrumb: ':eventname' },
              },
              {
                path: 'edit',
                component: EventEditComponent,
                data: { breadcrumb: 'edit' },
              },
              {
                path: 'registrations',
                component: EventRegistrationsComponent,
                data: { breadcrumb: 'Registrations' }
              }
            ]
          }
        ]
      },
    ],
    canActivate: [authnGuard(), authzGuard(['ROLE_ADMIN', 'ROLE_SUPER'])],
    canActivateChild: [authnGuard(), authzGuard(['ROLE_ADMIN', 'ROLE_SUPER'])],
  },
  {
    path: 'auth', component: SimpleLayoutComponent,
    children: [
      { path: 'signin', component: LoginComponent },
      { path: 'signout', component: LoginComponent },
      { path: 'setpassword', component: SetPasswordComponent },
      { path: 'resetpassword', component: ResetPasswordComponent },
      { path: '**', redirectTo: 'admin', pathMatch: 'full' }
    ]
  },
  {
    path: 'error', component: SimpleLayoutComponent,
    children: [
      { path: '404', component: NotFoundComponent },
      { path: '403', component: NotAuthorisedComponent },
      { path: '**', component: NotFoundComponent },
    ]
  },
  {
    path: 'welcome', component: WelcomeComponent
  },
  {
    path: ':eventname',
    component: RegistrationLayoutComponent,
    canActivate: [eventExistsGuard],
    resolve: { event: eventResolver },
    children: [
      { path: '', component: RegistrationWrapperComponent },
      { path: 'confirm', component: RegistrationConfirmComponent, canActivate: [RegistrationFlowGuard] },
      { path: 'pending', component: PaymentPendingComponent, canActivate: [RegistrationFlowGuard] },
      // { path: 'success', component: RegistrationSuccessComponent },
      { path: 'cancel', component: RegistrationCancelComponent, canActivate: [RegistrationFlowGuard] },
      { path: '**', redirectTo: '', pathMatch: 'full' }
    ]
  },
  { path: '**', component: WelcomeComponent }
];

